export const getPromotionLineStockCap = (product, pricingType) => {
    if (!product) return null;
    const isPiece = pricingType === 'Piece' || pricingType === 'piece';
    let raw = isPiece
        ? (product.availablePieceQty ?? product.available_piece_qty)
        : (product.availableBoxQty ?? product.available_box_qty);
    if (raw === undefined || raw === null || raw === '') {
        raw = product.available_qty ?? product.availableQty;
    }
    if (raw === undefined || raw === null || raw === '') {
        const candidates = [
            product.stock,
            product.stock_qty,
            product.available_stock,
            product.quantity_on_hand,
        ];
        raw = candidates.find(
            (v) =>
                v !== undefined &&
                v !== null &&
                v !== '' &&
                String(v).toLowerCase() !== 'null'
        );
    }
    const n = parseFloat(String(raw).trim().replace(/,/g, ''));
    if (!Number.isFinite(n)) return null;
    if (n < 0) return 0;
    return n;
};

export const promotionStockLimitSnackbarState = ({ productName, capFloor }) => ({
    open: true,
    severity: 'warning',
    useStockDialog: true,
    stockDialog: {
        productName: productName || 'Product',
        maxQty: Math.max(0, Math.floor(Number(capFloor))),
    },
});

export const buildPromotionMaxGetBlockedDialogState = (product) => ({
    open: true,
    productName: product?.product_name || product?.name || '',
    productCode: product?.product_code || product?.code || '',
    maxQty: undefined,
    message: 'Maximum quantity reached.',
    plainTitle: 'Maximum quantity reached',
});

export const getStockCapForCartLineItem = (lineLike) => {
    if (!lineLike) return null;
    const pricingType =
        lineLike.piece_type || lineLike.order_type || lineLike.type || 'Box';
    return getPromotionLineStockCap(lineLike, pricingType);
};

export const isQuantityWithinLineStock = (lineLike, targetQty, allowDecimal) => {
    const cap = getStockCapForCartLineItem(lineLike);
    if (cap === null || !Number.isFinite(cap)) return true;
    const t = Number(targetQty);
    if (!Number.isFinite(t)) return false;
    if (allowDecimal) return t <= cap + 1e-9;
    return t <= Math.floor(cap);
};
